<template>
  <v-container fluid>
    <v-row>
      <v-col md="6">
        <v-row>
          <v-col md="4">Company Name:</v-col>
          <v-col md="8">
            <div class="skeleton-box" style="width: 50%; height: 16px; border-radius: 10px;" v-if="!company.banding_description"></div>
              <div v-else>  {{ company.company_name }} </div>
              </v-col>
        </v-row>
        <v-row>
          <v-col md="4">Banding:</v-col>
          <v-col md="8">
            <div class="skeleton-box" style="width: 50%; height: 16px; border-radius: 10px;" v-if="!company.banding_description"></div>
            <div v-else>   {{ company.banding_description.name }} </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="4">State:</v-col>
          <v-col md="8">
            <div class="skeleton-box" style="width: 50%; height: 16px; border-radius: 10px;" v-if="!company.banding_description"></div>
            <div v-else>{{ company.state_description }}</div>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="4">Total Users:</v-col>
          <v-col md="8">
            <div class="skeleton-box" style="width: 50%; height: 16px; border-radius: 10px;" v-if="!company.banding_description"></div>
            <div v-else>{{ company.total_employees }}</div></v-col>
        </v-row>
        <v-row>
          <v-col md="4">Total Courses:</v-col>
          <v-col md="8">
            <div class="skeleton-box" style="width: 50%; height: 16px; border-radius: 10px;" v-if="!company.banding_description"></div>
            <div v-else>{{ company.total_courses }}</div>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="4">Subscription Date</v-col>
          <v-col md="8">
            <div class="skeleton-box" style="width: 50%; height: 16px; border-radius: 10px;" v-if="!company.banding_description"></div>
            <div v-else>{{ company.subscription_date_formatted }}</div>
          </v-col>
        </v-row>
      </v-col>
      <v-col md="6">
        <v-row>
          <v-col md="4">Administrator:</v-col>
          <v-col md="8">
          <div class="skeleton-box" style="width: 50%; height: 16px; border-radius: 10px;" v-if="!company.banding_description"></div>
          <div v-else>{{ company.company_owner_name }}</div>
        </v-col>
        </v-row>
        <v-row v-if="$globalConfig.APP_NAME == 'partner'">
          <v-col md="4">Package:</v-col>
          <v-col md="8">
          <div class="skeleton-box" style="width: 50%; height: 16px; border-radius: 10px;" v-if="!company.banding_description"></div>
          <div v-else>{{ company.package ? company.package.title : '-'}}</div></v-col>
        </v-row>
        <v-row>
          <v-col md="4">Email:</v-col>
          <v-col md="8">
          <div class="skeleton-box" style="width: 50%; height: 16px; border-radius: 10px;" v-if="!company.banding_description"></div>
          <div v-else>{{ company.company_owner_email }}</div></v-col>
        </v-row>
        <v-row v-if="$globalConfig.APP_NAME == 'direct'">
          <v-col md="4">Lead From:</v-col>
          <v-col md="8">
          <div class="skeleton-box" style="width: 50%; height: 16px; border-radius: 10px;" v-if="!company.banding_description"></div>
          <div v-else>{{ company.lead_from }}</div></v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  name: "SuperAdminCompanyDetails",
  components: {
  },
  props: {
    detail: {
      type: [Array, Object],
    },
  },
  data() {
    return {
      company: [],
    };
  },
  computed: {},
  watch: {
    detail: {
      handler(value) {
        this.company = value;
      },
      deep: true,
    },
  },
};
</script>
